import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/error-rounded.svg'


const _withScopeId = n => (_pushScopeId("data-v-6afa9904"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "div-info-note-frame"
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { class: "div-page-content-desc" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "div-page-content-area" }
const _hoisted_7 = { id: "registering-subtitle-basic-h3" }
const _hoisted_8 = { class: "div-columns" }
const _hoisted_9 = { class: "div-registering-input-container" }
const _hoisted_10 = {
  id: "registering-firstname-input-label",
  class: "registering-row-label-disabled full-row-input",
  for: "registering-firstname-input"
}
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = { class: "div-registering-input-container" }
const _hoisted_13 = {
  id: "registering-lastname-input-label",
  class: "registering-row-label-disabled full-row-input",
  for: "registering-lastname-input"
}
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "div-registering-label-row" }
const _hoisted_16 = {
  class: "full-row-label",
  id: "registering-telephone-input-label",
  for: "registering-telephone-input"
}
const _hoisted_17 = { class: "div-registering-input-row" }
const _hoisted_18 = ["placeholder", "disabled"]
const _hoisted_19 = { class: "div-registering-label-row" }
const _hoisted_20 = {
  class: "full-row-label",
  id: "registering-email-input-label",
  for: "registering-email-input"
}
const _hoisted_21 = { class: "div-registering-input-row" }
const _hoisted_22 = ["placeholder", "disabled"]
const _hoisted_23 = { class: "div-registering-label-row" }
const _hoisted_24 = {
  id: "registering-street-address-input-label",
  class: "full-row-label",
  for: "registering-street-address-input"
}
const _hoisted_25 = { class: "div-registering-input-row" }
const _hoisted_26 = ["placeholder", "disabled"]
const _hoisted_27 = { class: "div-columns" }
const _hoisted_28 = { class: "div-registering-input-container" }
const _hoisted_29 = {
  id: "registering-postal-code-input-label",
  class: "registering-row-label full-row-input",
  for: "registering-postal-code-input"
}
const _hoisted_30 = ["placeholder", "disabled"]
const _hoisted_31 = { class: "div-registering-input-container" }
const _hoisted_32 = {
  class: "registering-row-label full-row-input",
  id: "registering-post-office-input-label",
  for: "registering-post-office-input"
}
const _hoisted_33 = ["placeholder", "disabled"]
const _hoisted_34 = { class: "div-registering-label-row" }
const _hoisted_35 = {
  id: "registering-country-input-label",
  class: "full-row-label",
  for: "registering-country-input"
}
const _hoisted_36 = { class: "div-registering-dropdown" }
const _hoisted_37 = { id: "p-after-selectable" }
const _hoisted_38 = { id: "registering-subtitle-important-h3" }
const _hoisted_39 = { id: "registering-subtitle-agreement-h3" }
const _hoisted_40 = { class: "div-checkbox-container" }
const _hoisted_41 = { class: "divCheckbox" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "divCheckbox" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { class: "divCheckbox" }
const _hoisted_46 = ["disabled"]
const _hoisted_47 = ["href"]
const _hoisted_48 = {
  key: 1,
  class: "div-error-note"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redIconArea" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "error-icon",
    src: _imports_0
  })
], -1))
const _hoisted_50 = { class: "pErrorCheckbox" }
const _hoisted_51 = {
  key: 2,
  style: {"margin-bottom":"25px"}
}
const _hoisted_52 = { id: "registering-subtitle-finish-h3" }
const _hoisted_53 = {
  key: 3,
  class: "div-error-note"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "redIconArea" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "filterRed",
    src: _imports_0
  })
], -1))
const _hoisted_55 = { class: "bodyErrorArea" }
const _hoisted_56 = { class: "two-button-container" }
const _hoisted_57 = ["disabled"]

import { ref, computed, onBeforeMount, onBeforeUnmount } from "vue";
import { requiredInject } from "@/util/vue";
import { BackendKey } from "@/backend";
import { Store } from "vuex";
import { index } from "@/store/index";
import CustomAlertNote from "@/components/CustomAlertNote.vue";
import CustomInfoNoteConfirmation from "@/components/CustomInfoNoteConfirmation.vue";
import CustomDropDown from "@/components/CustomDropDown.vue";
import {
  checkAndMarkStringLength,
  checkEmailValidity,
  checkPhoneNumberValidity,
  getFirstErrorElementTopPosition,
  setErrorFromResponse
} from "@/util/commonUtils";
import {
  updateStore,
  getUserAcceptedConsentVersion,
  getSelectedLanguage
} from "@/util/commonStoreUtils";
import { ErrorField, InputLengths } from "@/util/commonTypes";
import {
  RegistrationRequest,
  RegistrationResponse,
  ConsentTextAction,
  ConsentTextType
} from "@/backend/types/registration";
import { HttpStatus } from "@/backend/types/response";

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'RegisteringI18nRegisteringForm',
  emits: ["cancelRegisteringProcess", "unauthorizedLogout", "continueToTreatmentHistory", "showSpinner"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const store: Store<unknown> = index;

const backend = requiredInject(BackendKey);

const screenPosition = ref<number>(0);
const inProgress = ref<boolean>();
const showCancelConfirmation = ref<boolean>(false);
const submittedOnce = ref<boolean>(false);
const errorFromResponse = ref<string | number | null>(null);

onBeforeMount(() => {
  inProgress.value = false;
  firstName.value = store.getters.getUserFirstName;
  lastName.value = store.getters.getUserLastName;
  /*
  socialSecurityNumber.value = store.getters.getUserSSN;
  */
  telephoneNumber.value = store.getters.getUserPhoneNumber;
  email.value = store.getters.getUserEmailAddress;
  streetAddress.value = store.getters.getUserStreetAddress;
  postalCode.value = store.getters.getUserPostalCode;
  postOffice.value = store.getters.getUserCity;
  // If registering an existing Acute patient to MyDocrates, keep the
  // business language they already had in Acute.  Otherwise default it
  // to the chosen frontend language.
  languageCode.value =
    store.getters.getUserLanguageCode || getLanguage() || "fi";
  country.value = store.getters.getUserCountryCode || store.getters.country;
});

onBeforeUnmount(() => {
  // reset values if user navigates away from the page using back button
  inProgress.value = false;
  store.commit("SET_INFO_OVERLAY", null);
});

const firstName = ref<string>();
const lastName = ref<string>();
/*
const socialSecurityNumber = ref<string>();
 */
const telephoneNumber = ref<string>();
const email = ref<string>();
const streetAddress = ref<string>();
const postalCode = ref<string>();
const postOffice = ref<string>();
const languageCode = ref<string>();
const country = ref<string>();

const checkedBasicInfo = ref<boolean>();
const checkedPatientRegister = ref<boolean>();
const checkedTermsOfUse = ref<boolean>();

const errorFields = ref<ErrorField[]>([]);

/**
 * True if any of agreement checkboxes is not ticked.
 */
const errorCheckbox = computed<boolean>(() => {
  return !(
    checkedBasicInfo.value &&
    checkedPatientRegister.value &&
    checkedTermsOfUse.value
  );
});

/**
 * True if any error fields.
 */
const errorGeneral = computed<boolean>(() => {
  return errorFields.value.length > 0;
});

function inputHasError(fieldStr: string) {
  return errorFields.value.find(x => x.item === fieldStr);
}

function scrollBack() {
  if (screenPosition.value > -1) {
    window.scrollTo({ top: screenPosition.value, behavior: "smooth" });
    screenPosition.value = -1;
  }
}

function cancelRegisteringProcess(): void {
  emit("cancelRegisteringProcess");
}

function askCancelProcess(): void {
  screenPosition.value = window.pageYOffset;
  showCancelConfirmation.value = true;
}

function dismissCanceling(): void {
  showCancelConfirmation.value = false;
  // hack because note visibility is made by async items
  setTimeout(scrollBack, 50);
}

function resetError(fieldStr: string): void {
  errorFields.value = errorFields.value.filter(x => x.item !== fieldStr);
}

function getInputPlaceholder() {
  return store.getters.translate("answer");
}

function checkAndMarkPhoneNumberValidity(): void {
  if (!checkPhoneNumberValidity(telephoneNumber.value ?? "")) {
    errorFields.value.push({ item: "telephoneNumber" });
  }
}

function checkAndMarkEmailValidity(): void {
  if (!checkEmailValidity(email.value ?? "")) {
    errorFields.value.push({ item: "email" });
  }
}

/**
 * Terrible field validator.
 * Mutates errorFields glob by adding erronous fields by tag there,
 * so to check if all fields are valid is to check `errorFields.value.length`.
 */
function validateFields(): void {
  checkAndMarkStringLength(
    firstName.value ?? "",
    InputLengths.FIRSTNAME_MIN,
    InputLengths.FIRSTNAME_MAX,
    "firstName",
    errorFields.value
  );
  checkAndMarkStringLength(
    lastName.value ?? "",
    InputLengths.LASTNAME_MIN,
    InputLengths.LASTNAME_MAX,
    "lastName",
    errorFields.value
  );
  /*
  checkAndMarkStringLength(
    socialSecurityNumber.value ?? "",
    InputLengths.SSN,
    (store.getters.getUserAuthMethod as AuthMethod) != AuthMethod.FTN
      ? InputLengths.SSN_I18N_MAX
      : InputLengths.SSN,
    "socialSecurityNumber",
    errorFields.value
  );
  */
  if (
    checkAndMarkStringLength(
      telephoneNumber.value ?? "",
      InputLengths.TEL_MIN,
      InputLengths.TEL_MAX,
      "telephoneNumber",
      errorFields.value
    )
  ) {
    checkAndMarkPhoneNumberValidity();
  }
  if (
    checkAndMarkStringLength(
      email.value ?? "",
      InputLengths.EMAIL_MIN,
      InputLengths.EMAIL_MAX,
      "email",
      errorFields.value
    )
  ) {
    checkAndMarkEmailValidity();
  }
  checkAndMarkStringLength(
    streetAddress.value ?? "",
    InputLengths.STREET_MIN,
    InputLengths.STREET_MAX,
    "streetAddress",
    errorFields.value
  );
  checkAndMarkStringLength(
    postalCode.value ?? "",
    InputLengths.POSTALCODE_MIN,
    InputLengths.POSTALCODE_MAX,
    "postalCode",
    errorFields.value
  );
  checkAndMarkStringLength(
    postOffice.value ?? "",
    InputLengths.POSTOFFICE_MIN,
    InputLengths.POSTOFFICE_MAX,
    "postOffice",
    errorFields.value
  );
  checkCountrySelection(
    country.value ?? "", 
    "country", 
    errorFields.value
  );

  if (!checkedBasicInfo.value) {
    errorFields.value.push({ item: "checkedBasicInfo" });
  }
  if (!checkedPatientRegister.value) {
    errorFields.value.push({ item: "checkedPatientRegister" });
  }
  if (!checkedTermsOfUse.value) {
    errorFields.value.push({ item: "checkedTermsOfUse" });
  }
}

function checkCountrySelection(val: string, tag: string, errorFields: ErrorField[]): boolean {
  const CODE_LENGTH = 2;
  // WW is universal international mark all the way from CountryAndLanguageInitialization, not real country
  if (val === "WW" || val.length !== CODE_LENGTH) {
    errorFields.push({ item: tag });
    return false;
  }
  return true;
}

function getLanguage(): string {
  return getSelectedLanguage();
}

/**
 * Not only "continues process", but also sends the registration data.
 */
async function continueProcess(): Promise<void> {
  if (inProgress.value || submittedOnce.value) return;
  inProgress.value = true;
  validateFields();
  if (errorCheckbox.value || errorGeneral.value) {
    inProgress.value = false;
    // Scroll smoothly up to display errorenous input if any
    window.scrollTo({
      top: getFirstErrorElementTopPosition(
        errorFields.value,
        errorCheckbox.value
      ),
      behavior: "smooth"
    });
  } else {
    // if all's in order on form, start registering
    await doRegister();
  }
}

/**
 * Registers user to backend and sets user data for session.
 * This function is 99% copypasted from Registering:doRegister.
 * Will evoke parent component navigation via emits.
 */
async function doRegister(): Promise<void> {
  emit("showSpinner", true);
  // prevent resubmits if it had already succeeded once
  if (submittedOnce.value) {
    inProgress.value = false;
    emit("showSpinner", false);
    return;
  }
  // that awful validator should hypothetically work to block process here
  // but I don't trust code I don't understand so let's just check again
  if (!checkCountrySelection(country.value ?? "", "country", errorFields.value)) {
    return;
  }

  const registerObject = {
    phoneNumber: telephoneNumber.value?.trim() ?? "",
    emailAddress: email.value?.trim() ?? "",
    streetAddress: streetAddress.value?.trim() ?? "",
    postalCode: postalCode.value?.trim() ?? "",
    city: postOffice.value?.trim() ?? "",
    languageCode: languageCode.value?.trim() ?? "",
    countryCode: country.value?.trim() ?? "",
    consents: [
      {
        type: ConsentTextType.CentralReg,
        action: ConsentTextAction.UserAccepted,
        lang: getLanguage(),
        version: getUserAcceptedConsentVersion(),
        timestamp: "" // Can be empty in request
      }
    ]
  } as RegistrationRequest;

  // this is where form data is sent to backend
  const response: RegistrationResponse = await backend.register(registerObject);

  switch (response.status) {
    case HttpStatus.CREATED:
      submittedOnce.value = true; //pls don't set this to false elsewhere thx
      updateStore(registerObject, response);
      //after i18n registration always go to treatment history
      emit("continueToTreatmentHistory");
      break;
    case HttpStatus.BAD_REQUEST: // Bad Request, i.e. validation error
      response.constraintViolations?.forEach(validationError => {
        setErrorFromResponse(errorFields.value, validationError.path);
      });
      break;
    case HttpStatus.UNAUTHORIZED:
      emit("unauthorizedLogout");
      break;
    // Network error, Too many requests (429), etc.
    // Might need more separation in the future.
    default: {
      errorFromResponse.value = response.status;
      break;
    }
  }
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
  emit("showSpinner", false);
  inProgress.value = false;
}

function getTermsOfUseLink() {
  let url = "https://mydocrates-documents-bucket83908e77-n3v6k36cznck.s3.eu-central-1.amazonaws.com/";
  switch (store.getters.locale) {
    case "fi-FI":
      url += "MyDocrates-kayttoehdot.pdf";
      break;
    case "sv-FI":
      url += "MyDocrates-kayttoehdot-sv_Finland.pdf";
      break;
    // In Sweden, this for both swedish and finnish.
    case "fi-SE":
    case "sv-SE":
      url += "MyDocrates-kayttoehdot-sv_Sverige.pdf";
      break;
    default:
      url += "MyDocrates-kayttoehdot-2023-eng.pdf";
      break;
  }
  return url;
}

const initValueForDropDown = computed(() => {
  let ret = "";
  ret = store.getters.translate("generic-select-alt");
  return ret;
});

const labelForDropDown = computed(() => {
  let ret = "";
  ret = store.getters.translate("treatment-language");
  return ret;
});

const optionsForDropDown = computed(() => {
  let options = [""];
  options = [
    store.getters.translate("lang-finnish"),
    store.getters.translate("lang-swedish"),
    store.getters.translate("lang-english")
  ];
  return options;
});

const selectedForDropDown = computed(() => {
  let ret = "";
  switch (languageCode.value) {
    case "fi":
      ret = store.getters.translate("lang-finnish");
      break;
    case "sv":
      ret = store.getters.translate("lang-swedish");
      break;
    case "en":
      ret = store.getters.translate("lang-english");
      break;
  }
  return ret;
});

function languageSelectionChanged(value: string): void {
  if (value === store.getters.translate("lang-finnish")) {
    languageCode.value = "fi";
  } else if (value === store.getters.translate("lang-swedish")) {
    languageCode.value = "sv";
  } else if (value === store.getters.translate("lang-english")) {
    languageCode.value = "en";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_country_select = _resolveComponent("country-select")!

  return (errorFromResponse.value !== null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CustomAlertNote, {
          title: _unref(store).getters.translate('alert-registering-failed-title'),
          text: _unref(store).getters.translate('alert-registering-failed-text'),
          subtext: _unref(store).getters.translate('alert-registering-failed-subtext'),
          button: _unref(store).getters.translate('generic-return'),
          onRedirect: _cache[0] || (_cache[0] = ($event: any) => (errorFromResponse.value = null))
        }, null, 8, ["title", "text", "subtext", "button"])
      ]))
    : (showCancelConfirmation.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CustomInfoNoteConfirmation, {
            msg: "COMMON-CONFIRMATION",
            title: _unref(store).getters.translate('abort-registering'),
            header: _unref(store).getters.translate('registering-i18n-abort-confirmation'),
            text1: _unref(store).getters.translate('registering-i18n-abort-description'),
            button1: _unref(store).getters.translate('generic-return-b'),
            button2: _unref(store).getters.translate('abort-registering'),
            onCloseNote: dismissCanceling,
            onCancelOrChange: cancelRegisteringProcess
          }, null, 8, ["title", "header", "text1", "button1", "button2"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_unref(store).getters.translate("registering")), 1),
            _hoisted_5,
            _createElementVNode("sub", null, _toDisplayString(_unref(store).getters.translate("registering-i18n-identification-success")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, _toDisplayString(_unref(store).getters.translate("basic-info")), 1),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(store).getters.translate("firstname")), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "registering-firstname-input",
                  class: "registering-row-input-disabled full-row-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (resetError('firstName'))),
                  placeholder: getInputPlaceholder(),
                  disabled: ""
                }, null, 40, _hoisted_11), [
                  [_vModelText, firstName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(store).getters.translate("lastname")), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "registering-lastname-input",
                  class: "registering-row-input-disabled full-row-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastName).value = $event)),
                  onChange: _cache[4] || (_cache[4] = ($event: any) => (resetError('lastName'))),
                  placeholder: getInputPlaceholder(),
                  disabled: ""
                }, null, 40, _hoisted_14), [
                  [_vModelText, lastName.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(store).getters.translate("phone-number")), 1)
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives(_createElementVNode("input", {
                id: "registering-telephone-input",
                type: "tel",
                class: _normalizeClass(["full-row-input", {
            'validation-error': inputHasError('telephoneNumber')
          }]),
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((telephoneNumber).value = $event)),
                onChange: _cache[6] || (_cache[6] = ($event: any) => (resetError('telephoneNumber'))),
                placeholder: getInputPlaceholder(),
                disabled: inProgress.value
              }, null, 42, _hoisted_18), [
                [_vModelText, telephoneNumber.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(store).getters.translate("email")), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                id: "registering-email-input",
                type: "email",
                class: _normalizeClass(["full-row-input", {
            'validation-error': inputHasError('email')
          }]),
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((email).value = $event)),
                onChange: _cache[8] || (_cache[8] = ($event: any) => (resetError('email'))),
                placeholder: getInputPlaceholder(),
                disabled: inProgress.value
              }, null, 42, _hoisted_22), [
                [_vModelText, email.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(store).getters.translate("street-address")), 1)
            ]),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                id: "registering-street-address-input",
                type: "text",
                class: _normalizeClass(["full-row-input", {
            'validation-error': inputHasError('streetAddress')
          }]),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((streetAddress).value = $event)),
                onChange: _cache[10] || (_cache[10] = ($event: any) => (resetError('streetAddress'))),
                placeholder: getInputPlaceholder(),
                disabled: inProgress.value
              }, null, 42, _hoisted_26), [
                [_vModelText, streetAddress.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(store).getters.translate("postal-code")), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "registering-postal-code-input",
                  type: "text",
                  class: _normalizeClass(["registering-row-input full-row-input", {
              'validation-error': inputHasError('postalCode')
            }]),
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((postalCode).value = $event)),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (resetError('postalCode'))),
                  placeholder: getInputPlaceholder(),
                  disabled: inProgress.value
                }, null, 42, _hoisted_30), [
                  [_vModelText, postalCode.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("label", _hoisted_32, _toDisplayString(_unref(store).getters.translate("post-office")), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "registering-post-office-input",
                  type: "text",
                  class: _normalizeClass(["registering-row-input full-row-input", {
              'validation-error': inputHasError('postOffice')
            }]),
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((postOffice).value = $event)),
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (resetError('postOffice'))),
                  placeholder: getInputPlaceholder(),
                  disabled: inProgress.value
                }, null, 42, _hoisted_33), [
                  [_vModelText, postOffice.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, _toDisplayString(_unref(store).getters.translate("home-country")), 1)
            ]),
            _createVNode(_component_country_select, {
              modelValue: country.value,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((country).value = $event)),
              onChange: _cache[16] || (_cache[16] = ($event: any) => (resetError('country'))),
              country: _unref(store).getters.country === 'SE' ? 'SE' : country.value,
              disabled: _unref(store).getters.country === 'SE',
              disablePlaceholder: true,
              usei18n: false,
              class: _normalizeClass({'validation-error': inputHasError('country')})
            }, null, 8, ["modelValue", "country", "disabled", "class"]),
            _createElementVNode("div", _hoisted_36, [
              _createVNode(CustomDropDown, {
                label: labelForDropDown.value,
                "init-value": initValueForDropDown.value,
                options: optionsForDropDown.value,
                "selected-option": selectedForDropDown.value,
                "selection-index": 1,
                onChange: languageSelectionChanged
              }, null, 8, ["label", "init-value", "options", "selected-option"])
            ]),
            _createElementVNode("p", _hoisted_37, _toDisplayString(_unref(store).getters.translate("country-and-language-initialization-text-2")), 1),
            _createElementVNode("h3", _hoisted_38, _toDisplayString(_unref(store).getters.translate("registering-important")), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate("registering-important-1")), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate("registering-important-2")), 1),
            _createElementVNode("p", null, _toDisplayString(_unref(store).getters.translate("registering-important-3")), 1),
            _createElementVNode("h3", _hoisted_39, _toDisplayString(_unref(store).getters.translate("registering-mark-agreement")), 1),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: "checkboxBasicInfo",
                  class: _normalizeClass(["checkbox", {
              'checkbox-validation-error': inputHasError('checkedBasicInfo')
            }]),
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((checkedBasicInfo).value = $event)),
                  onChange: _cache[18] || (_cache[18] = ($event: any) => (resetError('checkedBasicInfo'))),
                  disabled: inProgress.value
                }, null, 42, _hoisted_42), [
                  [_vModelCheckbox, checkedBasicInfo.value]
                ]),
                _createElementVNode("label", {
                  class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: checkedBasicInfo.value
            }]),
                  for: "checkboxBasicInfo"
                }, _toDisplayString(_unref(store).getters.translate("registering-agreement-basic")), 3)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  id: "checkboxPatientRegister",
                  type: "checkbox",
                  class: _normalizeClass(["checkbox", {
              'checkbox-validation-error': inputHasError(
                'checkedPatientRegister'
              )
            }]),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((checkedPatientRegister).value = $event)),
                  onChange: _cache[20] || (_cache[20] = ($event: any) => (resetError('checkedPatientRegister'))),
                  disabled: inProgress.value
                }, null, 42, _hoisted_44), [
                  [_vModelCheckbox, checkedPatientRegister.value]
                ]),
                _createElementVNode("label", {
                  class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: checkedPatientRegister.value
            }]),
                  for: "checkboxPatientRegister"
                }, _toDisplayString(_unref(store).getters.translate(
                "registering-agreement-saving-to-register"
              )), 3)
              ]),
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  id: "checkboxTermsOfUse",
                  type: "checkbox",
                  class: _normalizeClass(["checkbox", {
              'checkbox-validation-error': inputHasError('checkedTermsOfUse')
            }]),
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((checkedTermsOfUse).value = $event)),
                  onChange: _cache[22] || (_cache[22] = ($event: any) => (resetError('checkedTermsOfUse'))),
                  disabled: inProgress.value
                }, null, 42, _hoisted_46), [
                  [_vModelCheckbox, checkedTermsOfUse.value]
                ]),
                _createElementVNode("label", {
                  class: _normalizeClass(["labelCheckbox", {
              labelCheckboxChecked: checkedTermsOfUse.value
            }]),
                  for: "checkboxTermsOfUse"
                }, _toDisplayString(_unref(store).getters.translate("registering-agreement-terms-of-use")), 3)
              ])
            ]),
            (getTermsOfUseLink())
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  id: "linkTermsOfUse",
                  href: getTermsOfUseLink(),
                  target: "_blank"
                }, _toDisplayString(_unref(store).getters.translate("registering-terms-of-use")), 9, _hoisted_47))
              : _createCommentVNode("", true),
            (errorCheckbox.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _hoisted_49,
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(store).getters.translate("accept-all-agreements")), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_51)),
            _createElementVNode("h3", _hoisted_52, _toDisplayString(_unref(store).getters.translate("registering-finish")), 1),
            (errorGeneral.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(store).getters.translate("registering-form-error")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("button", {
                id: "registering-return-button",
                class: "buttonReturn",
                onClick: askCancelProcess
              }, _toDisplayString(_unref(store).getters.translate("generic-return")), 1),
              _createElementVNode("button", {
                id: "registering-send-button",
                class: "buttonContinue",
                onClick: continueProcess,
                disabled: inProgress.value
              }, _toDisplayString(_unref(store).getters.translate("agree-and-send")), 9, _hoisted_57)
            ])
          ])
        ]))
}
}

})